import React from 'react';

const AutoshipIcon = () => {
  const iconColor = '#1790BA';
  return (
    <svg width="65" height="17" viewBox="0 0 65 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_430_14411" maskUnits="userSpaceOnUse" x="25" y="0" width="13" height="17">
        <path d="M25.3828 0.600098H37.1748V16.8235H25.3828V0.600098Z" fill="white" />
      </mask>
      <g mask="url(#mask0_430_14411)">
        <path
          d="M31.2784 2.81228V0.600098L28.3304 3.54967L31.2784 6.49964V4.28706C33.7218 4.28706 35.7005 6.26727 35.7005 8.71182C35.7005 9.46016 35.5127 10.1608 35.1884 10.7804L36.2642 11.857C36.8353 10.9424 37.1745 9.86935 37.1745 8.71182C37.1745 5.45242 34.5359 2.81228 31.2784 2.81228ZM31.2784 13.1362C28.8355 13.1362 26.8564 11.1564 26.8564 8.71182C26.8564 7.96308 27.0446 7.26285 27.3689 6.6432L26.2927 5.56665C25.7216 6.48086 25.3828 7.55389 25.3828 8.71182C25.3828 11.9712 28.021 14.6114 31.2784 14.6114V16.8235L34.2264 13.8736L31.2784 10.924V13.1362Z"
          fill={iconColor}
        />
      </g>
      <path
        d="M6.63269 12.5589H8.36449L6.76335 4.38611H4.98382L0.5 12.5589H2.25566L3.25202 10.6017H6.3123L6.63269 12.5589ZM3.98746 9.16645L5.56513 6.07018L6.07524 9.16645H3.98746Z"
        fill={iconColor}
      />
      <path
        d="M12.316 12.7012C13.9883 12.7012 15.6493 11.5508 15.9814 9.67656L16.9066 4.38611H15.2577L14.3443 9.56977C14.1428 10.6847 13.3596 11.1353 12.6007 11.1353C11.8297 11.1353 11.1889 10.6847 11.3908 9.56977L12.3042 4.38611H10.6553L9.71806 9.67656C9.39767 11.5508 10.6553 12.7012 12.316 12.7012Z"
        fill={iconColor}
      />
      <path
        d="M24.1987 4.38611H18.0422L17.793 5.84486H20.047L18.8609 12.5589H20.5094L21.6959 5.84486H23.9495L24.1987 4.38611Z"
        fill={iconColor}
      />
      <path
        d="M41.1118 12.7012C42.6538 12.7012 44.1838 11.8116 44.4803 10.1862C44.7295 8.79867 43.757 8.14617 42.5944 7.80231L41.7283 7.54099C40.9099 7.30393 40.922 6.87675 40.9694 6.67529C41.0523 6.12958 41.6219 5.7024 42.2623 5.7024C42.9621 5.7024 43.2942 6.15344 43.1992 6.73475H44.8363C45.1211 5.18055 44.0891 4.24365 42.547 4.24365C40.9811 4.24365 39.5458 5.25175 39.2967 6.71089C39.1664 7.44633 39.2967 8.52562 40.9929 9.00013L41.9419 9.28492C42.6061 9.49851 42.8909 9.8185 42.808 10.2695C42.7129 10.8509 42.1437 11.2538 41.42 11.2538C40.649 11.2538 40.1627 10.7675 40.2574 10.1862H38.6089C38.3715 11.6219 39.3678 12.7012 41.1118 12.7012Z"
        fill={iconColor}
      />
      <path
        d="M51.6952 4.38611L51.1021 7.75465H48.0536L48.6466 4.38611H46.9978L45.5625 12.5589H47.2114L47.7927 9.23765H50.8412L50.2599 12.5589H51.9088L53.3441 4.38611H51.6952Z"
        fill={iconColor}
      />
      <path
        d="M53.8984 12.5589H55.5473L56.9826 4.38611H55.3337L53.8984 12.5589Z"
        fill={iconColor}
      />
      <path
        d="M62.3116 4.38611H58.9782L57.543 12.5589H59.1918L59.7019 9.70003H61.3743C63.2246 9.70003 64.2687 8.39542 64.5058 7.05481C64.7432 5.71459 64.1619 4.38611 62.3116 4.38611ZM62.8569 7.05481C62.7505 7.63612 62.3472 8.25302 61.564 8.25302H59.9507L60.3779 5.84486H62.0029C62.774 5.84486 62.952 6.46176 62.8569 7.05481Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default AutoshipIcon;
